import { render } from "./PopupNoteList.vue?vue&type=template&id=3d5c60cf&scoped=true"
import script from "./PopupNoteList.vue?vue&type=script&lang=js"
export * from "./PopupNoteList.vue?vue&type=script&lang=js"

import "./PopupNoteList.vue?vue&type=style&index=0&id=3d5c60cf&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5c60cf"]])

export default __exports__